import React from "react";
import { getRecentlyViewed } from "../lib/store";
import ProductCard from "./ProductCard";

export default function RecentlyViewed({ excludeHandle }) {
  const recent = getRecentlyViewed(excludeHandle).slice(0, 4);
  if (recent.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-24">
      <div className="text-center mb-12">
        <p className="section-eyebrow">Pick Up Where You Left Off</p>
        <h2 className="section-title">Recently Viewed</h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
        {recent.map((p) => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
    </section>
  );
}
